/**
 * Driver ID (Iqama) validation and formatting (unified across all apps).
 * - Must be exactly 10 digits.
 */

export const DRIVER_ID_LENGTH = 10

/**
 * Strip non-digits from driver ID input.
 */
export function cleanDriverIdInput(value: string): string {
  return value.replace(/\D/g, '')
}

/**
 * Validate driver ID: exactly 10 digits.
 * Returns validation result with optional normalized value.
 */
export function validateDriverId(value: string): {
  valid: boolean
  normalized?: string
  errorKey?: string
} {
  if (typeof value !== 'string') {
    return { valid: false, errorKey: 'validation.driverIdFormat' }
  }
  const cleaned = cleanDriverIdInput(value.trim())
  if (cleaned.length === 0) {
    return { valid: false, errorKey: 'validation.driverIdRequired' }
  }
  if (cleaned.length !== DRIVER_ID_LENGTH) {
    return { valid: false, errorKey: 'validation.driverIdMustBe10Digits' }
  }
  if (!/^\d+$/.test(cleaned)) {
    return { valid: false, errorKey: 'validation.driverIdFormat' }
  }
  return { valid: true, normalized: cleaned }
}

/**
 * Normalize driver ID for storage: 10 digits only.
 * Returns null if invalid.
 */
export function normalizeDriverIdForStorage(value: string): string | null {
  const result = validateDriverId(value)
  return result.valid ? result.normalized ?? null : null
}
